// extracted by mini-css-extract-plugin
export var dark = "w_s7";
export var darkcookie = "w_s8";
export var tintedcookie = "w_s9";
export var regularcookie = "w_tb";
export var darkbase = "w_tc";
export var tintedbase = "w_td";
export var regularbase = "w_tf";
export var darkraw = "w_tg";
export var tintedraw = "w_th";
export var regularraw = "w_tj";
export var darkchick = "w_tk";
export var tintedchick = "w_tl";
export var regularchick = "w_tm";
export var darkherbarium = "w_tn";
export var tintedherbarium = "w_tp";
export var regularherbarium = "w_tq";
export var darkholiday = "w_tr";
export var tintedholiday = "w_ts";
export var regularholiday = "w_tt";
export var darkoffline = "w_tv";
export var tintedoffline = "w_tw";
export var regularoffline = "w_tx";
export var darkorchid = "w_ty";
export var tintedorchid = "w_tz";
export var regularorchid = "w_tB";
export var darkpro = "w_tC";
export var tintedpro = "w_tD";
export var regularpro = "w_tF";
export var darkrose = "w_tG";
export var tintedrose = "w_tH";
export var regularrose = "w_tJ";
export var darktimes = "w_tK";
export var tintedtimes = "w_tL";
export var regulartimes = "w_tM";
export var darkwagon = "w_tN";
export var tintedwagon = "w_tP";
export var regularwagon = "w_tQ";